export const admin = {
  // Gate states
  loading: '로딩 중...',
  deniedTitle: '접근 권한이 없습니다',
  deniedBody: '이 계정은 관리자로 등록되어 있지 않습니다.',
  logout: '로그아웃',

  // Login
  login: {
    label: 'Admin',
    title: '관리자 로그인',
    email: '이메일 주소',
    emailPlaceholder: 'admin@example.com',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력',
    submit: '로그인',
    submitting: '로그인 중...',
    invalidCredentials: '이메일 주소 또는 비밀번호가 올바르지 않습니다',
  },

  // Dashboard header
  brandLabel: 'EachTeach Admin',
  title: '서비스 관리',
  backToHome: '홈으로',

  // Stats / actions
  publishedServices: '공개 중인 서비스',
  unit: '건',
  addNew: '신규 추가',

  // Toasts
  toast: {
    updated: '서비스를 업데이트했습니다',
    updateFailed: '업데이트에 실패했습니다 (권한 또는 통신을 확인)',
    added: '서비스를 추가했습니다',
    addFailed: '추가에 실패했습니다 (권한 또는 통신을 확인)',
    deleted: '서비스를 삭제했습니다',
    deleteFailed: '삭제에 실패했습니다 (권한 또는 통신을 확인)',
  },

  // Service list
  list: {
    empty: '아직 서비스가 없습니다. "+ 신규 추가"에서 만들어 주세요.',
    edit: '편집',
    delete: '삭제',
    confirmDelete: '"{{name}}"을(를) 삭제하시겠습니까?',
    cancel: '취소',
    confirmDeleteButton: '삭제하기',
  },

  // Service form modal
  modal: {
    editTitle: '서비스 편집',
    addTitle: '새 서비스 추가',
    serviceName: '서비스명',
    serviceNamePlaceholder: '예: EachTeach 커뮤니티',
    shortDescription: '짧은 설명',
    shortDescriptionPlaceholder: '카드에 표시되는 한 줄 설명',
    detail: '상세 설명',
    detailPlaceholder: '"자세히 보기"로 펼쳐지는 자세한 설명 (500자 이내)',
    linkUrl: '링크 URL (선택)',
    image: '이미지',
    changeImage: '이미지 변경',
    clickToSelect: '클릭하여 이미지 선택',
    dragDrop: '또는 여기에 드래그 앤 드롭 (JPG・PNG・WebP)',
    imageUploading: '이미지 업로드 중...',
    imageTypeError: 'JPG・PNG・WebP 형식의 이미지를 선택해 주세요',
    imageSizeError: '이미지 크기는 5MB 이내여야 합니다',
    imageUploadError: '이미지 업로드에 실패했습니다 (권한 또는 통신을 확인)',
    cancel: '취소',
    update: '업데이트하기',
    add: '추가하기',
    requiredMark: '*',
  },
};
